import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

// Firebase configuration (same project as mobile app)
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyAUFuDcQwChWDQZ10Y7mn9oH-oezo93ZUk",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "cares-b1873.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "cares-b1873",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "cares-b1873.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "434011467015",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:434011467015:web:cares-web-app"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);

// Opt-in local emulators for testing. `import.meta.env.DEV` is false in `vite build`
// output, so a stray VITE_USE_EMULATORS can never point the live site at localhost.
// Ports overridable when the defaults are occupied by another project's emulators.
if (import.meta.env.DEV && import.meta.env.VITE_USE_EMULATORS === 'true') {
  const authPort = Number(import.meta.env.VITE_EMULATOR_AUTH_PORT || 9099);
  const firestorePort = Number(import.meta.env.VITE_EMULATOR_FIRESTORE_PORT || 8080);
  const functionsPort = Number(import.meta.env.VITE_EMULATOR_FUNCTIONS_PORT || 5001);
  connectAuthEmulator(auth, `http://localhost:${authPort}`, { disableWarnings: true });
  connectFirestoreEmulator(db, 'localhost', firestorePort);
  connectFunctionsEmulator(functions, 'localhost', functionsPort);
  console.log('Connected to Firebase emulators');
}

export default app;
